import * as React from 'react'
import { GolfServiceSlotCard } from './GolfServiceSlotCard/GolfServiceSlotCard'
import { GolfServiceSlotSheet } from './GolfServiceSlotSheet/GolfServiceSlotSheet'

interface GolfServiceSlotProps {
  slotId: string
}

export function GolfServiceSlot({ slotId }: GolfServiceSlotProps) {
  return (
    <>
      <GolfServiceSlotCard slotId={slotId} />
      <GolfServiceSlotSheet slotId={slotId} />
    </>
  )
}
